import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { formSubLayanan, IFormSubLayanan } from '../model.kategori';
import {
  UCreateKategori,
  UGetDetailKategori,
  UUpdateKategori,
} from '../../../usecase/kategori/kategori.usecase';
import { getAllListKategori } from '../../../data/kategori/kategori';
import { modalSuccess } from '../../../components/Modal/ModalSuccess';

export const useModelSubLayananForm = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form, setForm] = useState<IFormSubLayanan>(formSubLayanan);
  const [listLayanan, setLayananList] = useState<Array<any>>([]);

  async function fetchLayanan() {
    const temp: any = await getAllListKategori({ type: 'layanan' });
    setLayananList(temp.data);
  }

  useEffect(() => {
    fetchLayanan();
  }, []);

  useEffect(() => {
    async function fetchDetail(id: any) {
      const temp: any = await dispatch(UGetDetailKategori(id));
      setForm({
        ...temp.data,
        ...(temp.data.picture_url && {
          picture_url: temp.data.picture_url,
        }),
      });
    }

    if (id) {
      fetchDetail(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleSubmit = async (values: IFormSubLayanan) => {
    console.log(values);

    const formData = new FormData();

    formData.append('name', values.name);
    formData.append('code', values.code);
    formData.append(
      'file',
      values.picture_url ? values.picture_url.originFileObj || values.picture_url : '',
    );
    formData.append('display_index', values.display_index || '');
    formData.append('parent_id', values.parent_id || '');

    try {
      if (id) {
        formData.append('is_active', String(form.is_active));
        await dispatch(UUpdateKategori(id, formData));
        modalSuccess({ title: 'Data kamu berhasil diperbaharui', callback: () => navigate(-1) });
      } else {
        formData.append('is_active', '1');
        await dispatch(UCreateKategori(formData));
        modalSuccess({
          title: 'Kamu berhasil menambahkan data Sub Layanan',
          callback: () => navigate(-1),
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return {
    form,
    setForm,
    handleSubmit,
    listLayanan,
  };
};
